export default "__VITE_ASSET__CWJdZRrA__"